// @flow
import { Box, Chip, Typography } from "@mui/material";

type Props = {
	title: string,
	field?: any
}

const AccordionTitle = (props: Props) => {
	const { title, field } = props
	return (
		<>
			<Box sx={{ display: 'flex', alignItems: 'center' }}>
				<Typography variant={"subtitle2"}>{title}</Typography>
			</Box>
			{field &&
				<Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>
					<Chip
						label={field}
						sx={{ fontSize: '0.8rem' }}
					/>
				</Box>
			}
		</>
	)
}

export default AccordionTitle;